import React, { Fragment } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation'
import About from '../../components/about/about'
import ProjectSectionHome from '../../components/ProjectSection/ProjectSectionHome'
import ServiceSection from '../../components/ServiceSection/ServiceSection'

import Testimonial from '../../components/Testimonial/Testimonial'

import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Logo from '../../images/logo-2.svg'

const HomePage = () => {
  return (
    <Fragment>
      <Navbar
        hclass={'wpo-site-header wpo-header-style'}
        Logo={Logo}
        col1={'col-lg-3 col-md-2 col-2 d-lg-none dl-block'}
        col2={'col-lg-5 col-md-6 col-10'}
        col3={'col-lg-5 col-md-1 col-1'}
        col4={'col-lg-2 col-md-2 col-2'}
      />
      <Hero />
      <ScrollTextAnimation />
      {/* <About hclass={'wpo-about-section section-padding pb-0'} /> */}
      <ProjectSectionHome hclass={'wpo-project-section section-padding'} />
      <Testimonial hclass={'wpo-testimonial-section'} />
      <ServiceSection hclass={'wpo-service-section'} />

      <Footer />
      <Scrollbar />
    </Fragment>
  )
}

export default HomePage
